// https://day.js.org/docs/en/plugin/timezone
// https://day.js.org/docs/en/display/format
import { dayjs } from '../utils/date'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/de'
import 'dayjs/locale/en'

export default function () {
	dayjs.extend(localizedFormat)
	return dayjs
}
